import * as React from "react";
import { CSSProperties } from "react";
import { Button, Spinner } from "@fluentui/react-components";
import { DeleteRegular } from "@fluentui/react-icons";
import { pcpTokens } from "live-lesson/shared/feature-call-ui-react";


const buttonStyles: CSSProperties = {
    backgroundColor: "white",
    borderRadius: "24px",
    border: `1px solid ${pcpTokens.pcpColorNeutralStroke2}`,
    padding: '0px 12px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',

    lineHeight: '32px',
    letterSpacing: '0.52px',
};

type Props = {
    isClearing?: boolean;
    onClick: () => void;
};

export function ClearChatMessagesButton(props: Props) {
    const { isClearing, onClick } = props;

    return (
        <Button
            shape={'circular'}
            icon={isClearing ? <Spinner size="tiny" /> :  <DeleteRegular fontSize={16} color={pcpTokens.pcpColorNeutralStroke2} /> }
            onClick={onClick}
            size={'small'}
            style={buttonStyles}
        >
            alle löschen
        </Button>
    );
};
